import { render } from "./DiscountNotes.vue?vue&type=template&id=a82e9df4&scoped=true"
import script from "./DiscountNotes.vue?vue&type=script&lang=js"
export * from "./DiscountNotes.vue?vue&type=script&lang=js"

import "./DiscountNotes.vue?vue&type=style&index=0&id=a82e9df4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a82e9df4"]])

export default __exports__